import './App.css';
import './marketplace.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import HomeMarketplace from './pages/homeMarketplace';
import ServicesMarketplace from './pages/servicesMarketplace';
import FinderMarketplace from './pages/finderMarketplace';
import WarehouseDetailsMarketplace from './pages/warehouseDetailsMarketplace';
import ProviderMarketplace from './pages/providerMarketplace';
import BlogMarketplace from './pages/blogMarketplace';
import ContactMarketplace from './pages/contactMarketplace';
import BookingMarketplace from './pages/bookingMarketplace';
import BlogDetailMarketplace from './pages/blogDetailMarketplace';
import PrivacyPolicy from './pages/privacyPolicy';
import TermsOfService from './pages/termsOfService';
import CookiePolicy from './pages/cookiePolicy';
// Admin Components
import AdminLogin from './adminpage/admin';
import AdminRoutes from './adminpage/adminRoute'; // Import AdminRoutes
import AuthenticateRoute from './adminpage/authenticateRoute'; // Import the authentication guard
//User Components
import UserLogin from "./userPage/userLogin";
import UserRegister from './userPage/userRegister';
import AuthenticateUserRoute from './userPage/autheticatedUserRoute';
import UserRoute from './userPage/userRoute';
// import UserRegister from './userPage/userRegister';
//Client Components
import Clientlogin from './clientPage/clientLogin';
import ClientRegister from './clientPage/clientRegister';
import AuthenticateClientRoute from './clientPage/authenticatedClientRoute';
import ClientRoutes from './clientPage/clientRoute';
//marketer Components
import MarketerRegister from './marketerPage/marketerRegister';
import MarketerLogin from './marketerPage/marketerLogin';
import AuthenticateMarketerRoute from './marketerPage/autheticatedMarketerRoute';
import MarketerRoute from './marketerPage/marketerRoute';

function AppContent() {
  const location = useLocation();

  // Admin path detection for all admin-related pages
  const isAdminLogin = location.pathname.startsWith('/admin');
  const isAdminPage = location.pathname.startsWith('/adminDashboard');

  // User path detection for all user-related pages
  const isUserLogin = location.pathname.startsWith('/userLogin');
  const isUserRegister = location.pathname.startsWith('/registerUser');

  // Client path detection for all related pages
  const isClientRegister = location.pathname.startsWith('/registerClient');
  const isClientLogin = location.pathname.startsWith('/clientLogin');

  // Marketer path detection for all related pages
  const isMarketerRegistered = location.pathname.startsWith('/registerMarketer');
  const isMarketerLogin = location.pathname.startsWith('/marketerLogin');

  return (
    <>
      {/* Show Navbar and Footer only on non-admin pages */}
      {!isAdminLogin && !isAdminPage && !isUserLogin && !isUserRegister && !isClientLogin && !isClientRegister && !isMarketerRegistered && !isMarketerLogin && <Navbar />}

      <div className={isAdminPage ? 'admin-container' : ''}>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomeMarketplace />} />
          <Route path="/services" element={<ServicesMarketplace />} />
          <Route path="/finder" element={<FinderMarketplace />} />
          <Route path="/warehouseDetails/:id" element={<WarehouseDetailsMarketplace />} />
          <Route path="/3pl_booking" element={<BookingMarketplace />} />
          <Route path="/provider" element={<ProviderMarketplace />} />
          <Route path="/blog" element={<BlogMarketplace />} />
          <Route path="/blog/:id" element={<BlogDetailMarketplace />} />
          <Route path="/contact" element={<ContactMarketplace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />

          {/* Admin login route */}
          <Route path="/admin" element={<AdminLogin />} />

          {/* Admin routes */}
          <Route path="/adminDashboard/*" element={
            <AuthenticateRoute>
              <AdminRoutes />
            </AuthenticateRoute>
          } />

          {/* User login route */}
          <Route path="/userLogin" element={<UserLogin />} />
          <Route path="/registerUser" element={<UserRegister />} />

          {/* User routes */}
          <Route path="/userDetails/*" element={
            <AuthenticateUserRoute>
              <UserRoute />
            </AuthenticateUserRoute>
          } />

          {/* Client route */}
          <Route path="/registerClient" element={<ClientRegister />} />
          <Route path="/clientLogin" element={<Clientlogin />} />
          {/* Client routes */}
          <Route path="/clientDetails/*" element={
            <AuthenticateClientRoute>
              <ClientRoutes />
            </AuthenticateClientRoute>
          } />

          {/* Marketer routes */}
          <Route path="/registerMarketer" element={<MarketerRegister />} />
          <Route path="/marketerLogin" element={<MarketerLogin />} />
          <Route path="/marketerDetails/*" element={
            <AuthenticateMarketerRoute>
              <MarketerRoute />
            </AuthenticateMarketerRoute>
          } />
        </Routes>
      </div>

      {/* Show Footer only on non-admin pages */}
      {!isAdminLogin && !isAdminPage && !isUserLogin && !isUserRegister && !isClientLogin && !isClientRegister && !isMarketerRegistered && !isMarketerLogin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
